import { render, staticRenderFns } from "./SerieDocumental.vue?vue&type=template&id=2e6ae0a8"
import script from "./SerieDocumental.vue?vue&type=script&lang=js"
export * from "./SerieDocumental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6ae0a8')) {
      api.createRecord('2e6ae0a8', component.options)
    } else {
      api.reload('2e6ae0a8', component.options)
    }
    module.hot.accept("./SerieDocumental.vue?vue&type=template&id=2e6ae0a8", function () {
      api.rerender('2e6ae0a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/series-documentales/SerieDocumental.vue"
export default component.exports